import { render, staticRenderFns } from "./AdeptCustomLoader.vue?vue&type=template&id=5a6d9ce8&scoped=true&"
import script from "./AdeptCustomLoader.vue?vue&type=script&lang=js&"
export * from "./AdeptCustomLoader.vue?vue&type=script&lang=js&"
import style0 from "./AdeptCustomLoader.vue?vue&type=style&index=0&id=5a6d9ce8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d9ce8",
  null
  
)

export default component.exports